export default {
  en: {
    newMarket: 'Add Market',
    pleaseSelectMarket: 'Please select market',
    add: 'Add',
    cancel: 'Cancel'
  },
  th: {
    newMarket: 'Add Market',
    pleaseSelectMarket: 'Please select market',
    add: 'Add',
    cancel: 'Cancel'
  }
}
